/*global versaTagObj, fbq, snaptr, gtag, criteo_q, uetq, ttq*/
/*eslint no-undef: ["error", { "typeof": true }] */
import { UAParser } from 'ua-parser-js';

class CrmMultiTracking {
    
    constructor (hostname) {
        this.pageStartTime = Date.now();
        this.elements = [];
        this.initCampaignTracking(hostname);
        this.initPageTracking();
    }

    /**
     * =================================================================================================================
     * PAGINE E TEMPO
     * =================================================================================================================
     */

    initPageTracking () {
        const currentPath = window.location.pathname;
        const currentTitle = document.title;
        let pages = this.getFromStorage('pages', []);
        let totalTime = this.getFromStorage('totalTime', 0);

        const isAlreadyTracked = pages.some(p => p.url === currentPath);

        if (!isAlreadyTracked) {
            pages.push({
                url: currentPath,
                title: currentTitle,
                timestamp: new Date().toISOString()
            });
            if (pages.length > 20) {
                pages = pages.slice(pages.length - 20);
            }
            this.setToStorage('pages', pages);
        }

        this.setToStorage('totalTime', totalTime);
        this.pageStartTime = Date.now();

        window.addEventListener('beforeunload', () => {
            const timeSpent = Date.now() - this.pageStartTime;
            const currentTotal = this.getFromStorage('totalTime', 0);
            this.setToStorage('totalTime', currentTotal + timeSpent);
        });
    }

    updateTimeNow () {
        const now = Date.now();
        const timeSpent = now - this.pageStartTime;
        const currentTotal = this.getFromStorage('totalTime', 0);
        const newTotal = currentTotal + timeSpent;
        this.setToStorage('totalTime', newTotal);
        this.pageStartTime = now;
    }

    getPages () {
        return this.getFromStorage('pages', [])
    }

    getTime () {
        this.updateTimeNow()
        return Math.round(this.getFromStorage('totalTime', 0) / 1000)
    }

    resetTracking () {
        this.setToStorage('pages', []);
        this.setToStorage('totalTime', 0);
        this.pageStartTime = Date.now();
    }

    /**
     * =================================================================================================================
     * CAMPAGNA E IDENTIFICATIVI
     * =================================================================================================================
     */
  
    initCampaignTracking (hostname) {
        const search_organics = ['google', 'bing', 'ecosia', 'yahoo', 'duckduckgo', 'baidu', 'qwant', 'virgilio', 'ask', 'yandex', 'babylon', 'naver', 'sogou'];
        const social_organics = ['facebook', 'twitter', 'linkedin', 'instagram', 'youtube', 'pinterest', 'tiktok'];
        const referrer = document.referrer;
        let campaign = 'direct';
        let tracking = { campaign: 'direct', term: null, gclid: null, crm_id: null  };
        const cookie = this.cookie('crm_multi_tracking', null, true);
    
        if (cookie) {
            tracking = { ...tracking, ...cookie };
        }
    
        if (referrer) {
            const source = new URL(referrer).hostname.replace('www.', '');
            if (source !== hostname) {
                campaign = `${source}_referral`;
            if (search_organics.some(v => source.includes(v))) campaign = `${source}_organic`;
            else if (social_organics.some(v => source.includes(v))) campaign = `${source}_social`;
            }
        }
    
        const urlParams = new URLSearchParams(window.location.search);
        campaign = urlParams.get('gclid') ? 'googleads' : campaign;
        campaign = urlParams.get('utm_campaign') ?? campaign;
        campaign = urlParams.get('gcname') ?? campaign;
    
        tracking.campaign = campaign !== 'direct' ? campaign : tracking.campaign;
        tracking.term = urlParams.get('utm_term') ?? tracking.term;
    
        const gclid = urlParams.get('gclid');
        if (gclid && (!urlParams.get('gclsrc') || urlParams.get('gclsrc').includes('aw'))) {
            tracking.gclid = gclid;
        }
    
        const expires = new Date(Date.now() + (60 * 24 * 60 * 60 * 1000)).toUTCString();
        const value = JSON.stringify(tracking);
        const domain = '.' + hostname;
        document.cookie = `crm_multi_tracking=${value}; expires=${expires}; domain=${domain}; path=/`;
    
        this.elements.push(tracking);
    }

    /**
     * =================================================================================================================
     * DEVICE
     * =================================================================================================================
     */

    getDeviceInfo(name) {
        const parser = new UAParser();
        const result = parser.getResult();
        let data = {
            os: result.os.name,
            browser: result.browser.name,
            deviceType: result.device.type || 'desktop'
        };
        return name && data[name] !== undefined ? data[name] : data;
    }

    /**
     * =================================================================================================================
     * EVENTI
     * =================================================================================================================
     */

    /**
     * GA4 Lead
     * 
     * @param {string} event_label 
     */
    trackGALead (event_label) {
        if (typeof gtag !== 'undefined') {
            gtag('event', 'generate_lead', {
                'event_category': 'engagement',
                'event_label': event_label
            });
        }
    }

    /**
     * GA4 Iscrizione Online
     * 
     * @param {string} category 
     * @param {int} amount 
     */
    trackGAEnrol (category, amount) {
        if (typeof gtag !== 'undefined') {
            gtag('event', 'begin_checkout', {
                'event_category': 'ecommerce',
                'event_label': category,
                'value': amount
            })
        }
    }

    /**
     * Google Ads Lead
     * 
     * @param {string} category 
     * @param {int} amount 
     */
    trackGoogleAdsLead (event) {
        if (typeof gtag !== 'undefined') {
            gtag('event', 'conversion', {
                'send_to': event
            });
        }
    }

    /**
     * Google Ads Iscrizione Online
     * 
     * @param {string} category 
     * @param {int} amount 
     */
    trackGoogleAdsEnrol (send_to, category, amount, course) {
        if (typeof gtag !== 'undefined') {
            gtag('event', 'conversion', {
                'send_to': send_to,
                'value': amount,
                'currency': 'EUR',
                'category': category,
                'course': course
            });
        }
    }

    /**
     * Eventi Meta
     * 
     * @param {string} event 
     * @param {int} id 
     */
    trackFacebook (event, id) {
        if (typeof fbq !== 'undefined') {
            fbq('track', event, {}, { eventID: id });
        }
    }

    /**
     * Evento "Purchase" Meta
     * 
     * @param {string} code 
     * @param {int} value 
     */
    trackFacebookEnrol (event_id) {
        if (typeof fbq !== 'undefined' && event_id !== 0) {
            fbq('track', 'CompleteRegistration', {}, { eventID: event_id }) 
        }
    }

    /**
     * Floodlight Lead
     * 
     * @param {string} event 
     * @param {int} value 
     * @param {int} crm_id 
     * @param {int} category 
     * @param {string} course 
     * @param {string} ga_id 
     * @param {int} cid 
     * @param {string} email 
     * @param {string} phone_number 
     */
    trackFloodlightLead (event, value, crm_id, category, course, ga_id, cid, email, phone_number) {
        if (typeof gtag !== 'undefined') {
            gtag('event', 'purchase', {
                'allow_custom_scripts': true,
                'value': value,
                'transaction_id': crm_id,
                'quantity': '1',
                'u1': 'media',
                'u2': course,
                'u3': category,
                'u8': ga_id,
                'send_to': event,
                'dc_custom_params': { 'match_id': cid },
                'user_data': {
                    'email': email,
                    'phone_number': phone_number
                }
            });
        }
    }

    /**
     * Floodlight Iscrizione Online 
     * 
     * @param {string} send_to 
     * @param {int} crm_id 
     * @param {string} category 
     * @param {string} course 
     * @param {int} amount 
     * @param {string} gender 
     * @param {string} birth_date 
     * @param {string} ecp 
     * @param {string} entrance 
     * @param {string} ga_id 
     * @param {int} cid 
     */
    trackFloodlightEnrol (send_to, crm_id, category, course, amount, gender, birth_date, ecp, entrance, ga_id, cid) {
        if (typeof gtag !== 'undefined') {
            gtag('event', 'purchase', {
                'allow_custom_scripts': true,
                'value': amount,
                'transaction_id': crm_id,
                'quantity': '1',
                'u1': 'alta',
                'u2': course,
                'u3': category,
                'u4': gender,
                'u5': birth_date,
                'u6': ecp,
                'u7': entrance,
                'u8': ga_id,
                'send_to': send_to,
                'dc_custom_params': {
                    'match_id': cid,
                }
            });
        }
    }

    /**
     * Enhanced Conversion 
     * 
     * @param {string} email 
     * @param {string} telephone 
     */
    trackEnhancedConversion (email, telephone) {
        if (typeof gtag !== 'undefined') {
            gtag('set', 'user_data', {
                "email": email,
                "phone_number": telephone
            });
        }
    }

    /**
     * Bing Ads Lead
     * 
     * @param {string} event 
     */
    trackBingAds (event) {
        window.uetq = window.uetq || [];
        window.uetq.push('event', event, {});
    }

    /**
     * Bing Ads Iscrizione Online
     * 
     * @param {string} category 
     * @param {int} amount 
     */
    trackBingAdsEnrol (category, amount) {
        if (typeof uetq !== 'undefined') {
            uetq.push('event', 'signup', {
                "event_category": category,
                "revenue_value": amount,
                "currency": "EUR"
            });
        }
    }

    /**
     * TikTok Ads 
     * 
     * @param {string} event 
     * @param {string} email 
     * @param {string} telephone 
     */
    trackTikTokAds (event, email, telephone) {
        if (typeof ttq !== 'undefined') {
            ttq.identify({ email, phone_number: telephone });
            ttq.track(event);
        }
    }

    /**
     * CDP Pagine 
     * 
     */
    trackCdpPage () {
        window._adftrack = Array.isArray(window._adftrack)
            ? window._adftrack
            : (window._adftrack ? [window._adftrack] : []);

        window._adftrack.push({
            HttpHost: 'track.adform.net',
            pm: 3793778,
            divider: encodeURIComponent('|'),
            pagename: encodeURIComponent('DAN_UniPegaso_Website'),
            order: {
                sv7: encodeURIComponent(window.location.pathname + window.location.search),
                sv9: window.location.hostname.replace('www.', '')
            }
        });

        (function () {
            var s = document.createElement('script');
            s.type = 'text/javascript';
            s.async = true;
            s.src = 'https://s2.adform.net/banners/scripts/st/trackpoint-async.js';
            var x = document.getElementsByTagName('script')[0];
            x.parentNode.insertBefore(s, x);
        })()
    }

    /**
     * CDP Lead 
     * 
     * @param {string} hostname 
     * @param {int} id 
     * @param {string} subject 
     */
    trackCdpLead (contact_id, subject, type_id) {
        const types = {1: 'Informazioni', 2: 'Prova Gratuita', 3: 'Valutazione CFU', 4: 'Iscrizione Online'}
        window._adftrack = Array.isArray(window._adftrack)
            ? window._adftrack
            : (window._adftrack ? [window._adftrack] : []);

        window._adftrack.push({
            HttpHost: 'track.adform.net',
            pm: 3793778,
            divider: encodeURIComponent('|'),
            pagename: encodeURIComponent('DAN_UniPegaso_Website_TYP'),
            order: {
                sv7: encodeURIComponent(window.location.pathname + window.location.search),
                sv9: window.location.hostname.replace('www.', ''),
                sv10: contact_id,
                sv11: subject,
                sv12: types[type_id]
            }
        });

        (function () {
            var s = document.createElement('script');
            s.type = 'text/javascript';
            s.async = true;
            s.src = 'https://s2.adform.net/banners/scripts/st/trackpoint-async.js';
            var x = document.getElementsByTagName('script')[0];
            x.parentNode.insertBefore(s, x);
        })()
    }

    /**
     * =================================================================================================================
     * GA U-ID
     * =================================================================================================================
     */

    /**
     * Imposta User-Id in GA4
     * 
     * @param {string} config 
     */
    setGAUId (config) {
        const userId = this.get('crm_id')
        if (userId && typeof gtag !== 'undefined') {
            gtag('config', config, {
                'user_id': userId
            });
        } 
    }

    /**
     * =================================================================================================================
     * CONSENT MODE
     * =================================================================================================================
     */

    setConsentMode(action) {
        if (action == 'granted') {
            if (typeof gtag !== 'undefined') {
                gtag('set', 'allow_google_signals', true);
                gtag('consent', 'update', {
                    'analytics_storage': 'granted',
                    'ad_storage':'granted',
                    'ad_user_data': 'granted',
                    'ad_personalization': 'granted'
                });
                gtag('event', 'user_engagement', {
                    'event_category' : 'consent',
                    'event_label' : 'consent_granted'
                });
            }
            if (typeof uetq !== 'undefined') {
                window.uetq.push('consent', 'default', {
                    'ad_storage': 'granted'
                });
            }
        } else if (action == 'denied') {
            if (typeof gtag !== 'undefined') {
                gtag('event', 'user_engagement', {
                    'event_category' : 'consent',
                    'event_label' : 'consent_denied'
                });
            }
            if (typeof uetq !== 'undefined') {
                window.uetq.push('consent', 'default', {
                    'ad_storage': 'denied'
                });
            }
        }
    }

    /**
     * =================================================================================================================
     * HELPERS
     * =================================================================================================================
     */

    cookie (element, valueDefault = null, json = false) {
        let cookie = {};
        document.cookie.split(';').forEach(function(el) {
            let [key, value] = el.split('=');
            cookie[key.trim()] = value;
        });
  
        if (!cookie[element]) return valueDefault;
  
        let c = (element === '_ga' && cookie['_ga']) ? cookie['_ga'].substring(6) : cookie[element];
        return json ? JSON.parse(c) : c;
    }
  
    get (element, valueDefault = null) {
        if (this.elements[0]?.[element]) {
            return this.elements[0][element];
        } else if (this.cookie(element)) {
            return this.cookie(element, valueDefault);
        } else {
            return valueDefault;
        }
    }

    set (hostname, key, value) {
        let tracking = this.cookie('crm_multi_tracking', {}, true);
        if (typeof tracking !== 'object' || tracking === null) {
            tracking = {};
        }
    
        tracking[key] = value;
    
        const expires = new Date(Date.now() + (60 * 24 * 60 * 60 * 1000)).toUTCString();
        const domain = '.' + hostname;
        const cookieValue = JSON.stringify(tracking);
    
        document.cookie = `crm_multi_tracking=${cookieValue}; expires=${expires}; domain=${domain}; path=/`;
    
        if (this.elements.length > 0) {
            this.elements[0][key] = value;
        } else {
            this.elements.push(tracking);
        }
    }

    getFromStorage(key, defaultValue = null) {
        try {
            const value = localStorage.getItem('crm_tracking_' + key);
            return value ? JSON.parse(value) : defaultValue;
        } catch (e) {
            return defaultValue;
        }
    }
    
    setToStorage(key, value) {
        try {
            localStorage.setItem('crm_tracking_' + key, JSON.stringify(value));
        } catch (e) {
            console.warn('Storage set failed', e);
        }
    }

   
}
  
export default CrmMultiTracking;  